import React from 'react';
import {
  MdOutlineAccessTimeFilled,
  MdHistoryToggleOff,
  MdCheckCircle
} from 'react-icons/md';
import { TbAlertTriangleFilled } from 'react-icons/tb';

import { fromNow } from '../../utils/datetime';
import dayjs from 'dayjs';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

interface FormStatusProps {
  lastUpdated: string;
  isLoading: boolean;
}

const FormStatus: React.FC<FormStatusProps> = ({ isLoading, lastUpdated }) => {
  const { errors, submitCount } = useFormikContext<any>();
  const { t } = useTranslation(['events']);
  const totalErrors = Object.keys(errors)?.length || 0;

  // Only show publishing errors if the form has been submitted at least once
  if (submitCount > 0 && totalErrors > 0) {
    return (
      <span className="flex items-center text-red-700">
        <TbAlertTriangleFilled size={12} className="mr-1" />
        {t('events:host.publishFailed', {
          count: totalErrors
        })}
      </span>
    );
  }

  if (isLoading) {
    return (
      <span className="flex items-center text-yellow-600">
        <MdHistoryToggleOff size={12} className="mr-1" />
        {t('events:host.pending')}
      </span>
    );
  }

  // If the changes were within 5 seconds, show "changes saved successfully" message
  if (lastUpdated && dayjs().diff(dayjs(lastUpdated), 'second') <= 5) {
    return (
      <span className="text-green-700 text-sm flex items-center">
        <MdCheckCircle size={12} className="mr-1" />
        {t('events:host.changesSavedSuccessfully')}
      </span>
    );
  }

  if (lastUpdated) {
    return (
      <span className="text-gray-600 text-sm flex items-center">
        <MdOutlineAccessTimeFilled size={12} className="mr-1" />
        {t('events:host.updated', {
          date: fromNow(lastUpdated)
        })}
      </span>
    );
  }

  return (
    <span className="text-gray-600 text-sm flex items-center">
      <MdOutlineAccessTimeFilled size={12} className="mr-1" />
      {t('events:host.noChangesYet')}
    </span>
  );
};

export default FormStatus;
